import { not } from 'ramda';
import { ControlledDatePicker } from '@@viewCommonComponents/controlled';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer.jsx';
import useSimulationEffectDateForm from './hooks/useSimulationEffectDateForm.js';
import { FormProvider } from 'react-hook-form';
import { DashedTitle, Icon, InfoMessage, Message, PageTitle } from '@fasstech/middle-design-system';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';
import { isGroupOffer } from '@@viewEnums';
import SimulationEffectDateExtraForm from './extra/SimulationEffectDateExtraForm.jsx';
import SimulationEffectDateExtraInfoMessage from './extra/SimulationEffectDateExtraInfoMessage.jsx';

const SimulationEffectDateForm = ({
  getMiddleText,
  getSimulationEffectDate
}) => {
  const {
    form,
    dateIsCorrect,
    effectDate,
    effectDateDescription,
    minEffectDate,
    maxEffectDate,
    displayEffectDateError,
    isValid,
    onSubmit,
    offerCode,
    $onPrevClick,
    submitLoading
  } = useSimulationEffectDateForm({
    getSimulationEffectDate,
    getMiddleText
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <PageLayout className="overflow-x-hidden">
          <Icon name={'circle-calendar-icon'} size={70}/>
          <PageTitle
            data-testid={'PROCESSDEVENTE_EFFECT_DATE_VIEW_TITLE'}>{getMiddleText('PROCESSDEVENTE_EFFECT_DATE_VIEW_TITLE')}</PageTitle>
          <SimulationEffectDateExtraForm form={form} getMiddleText={getMiddleText}/>
          <DashedTitle>{getMiddleText('PROCESSDEVENTE_EFFECT_DATE_VIEW_SUBTITLE')}</DashedTitle>
          <ControlledDatePicker
            label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
            name="effectDate"
            form={form}
            minDate={minEffectDate}
            maxDate={maxEffectDate}
            data-testid="PROCESSDEVENTE_DATE_EFFET"
            triggerOnChange
          />
          {displayEffectDateError && (
            <Message
              className="w-full"
              variant={'error'}
              label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_ERROR')}
            />
          )}
          <InfoMessage iconName={'lightbulb'}>{effectDateDescription}</InfoMessage>
          <SimulationEffectDateExtraInfoMessage/>
        </PageLayout>
        <ButtonContainer
          $onPreviousButtonClick={$onPrevClick}
          displayPreviousButton={isGroupOffer(offerCode)}
          getMiddleText={getMiddleText}
          nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL')}
          nextButtonIsDisabled={not(dateIsCorrect(effectDate)) || submitLoading}
          isFormError={not(isValid)}
          displayResumeButton
        />
      </form>
    </FormProvider>
  );
};

export default SimulationEffectDateForm;
